import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, from, map, of, throwError } from 'rxjs';
import { AuthService } from '../../infrastructure/auth.service';
import { buildFirebaseAuthError, FirebaseAuthError } from '../utils';

interface ResetPasswordPayload {
  email: string;
}

@Injectable({ providedIn: 'root' })
export class ResetPasswordHandler {
  private readonly authService: AuthService = inject(AuthService);
  private readonly translate: TranslateService = inject(TranslateService);

  handle(payload: ResetPasswordPayload): Observable<void> {
    return from(this.authService.sendPasswordReset(payload.email)).pipe(
      map(() => void 0),
      catchError((err: { code?: string; message?: string }) => {
        const built: FirebaseAuthError = buildFirebaseAuthError(err, this.translate);
        if (built.code === 'auth/user-not-found' || built.code === 'auth/invalid-email') {
          return of(void 0);
        }
        return throwError(() => built);
      })
    );
  }
}
